import { PLAN_OPTIONS } from "../utils/planFeatures";
import { useGetPlanConfigQuery } from "../features/plans/planConfigApiSlice";

const formatPrice = (price) =>
  `${Number(price).toFixed(2).replace(".", ",")} € / Monat`;

/**
 * Returns PLAN_OPTIONS with prices and feature lists sourced from the server API.
 * Falls back to the static values in planFeatures.js if the request is still loading
 * or fails.
 */
const usePlanOptions = () => {
  const { data: planConfig } = useGetPlanConfigQuery();

  if (!planConfig?.plans) return PLAN_OPTIONS;

  return PLAN_OPTIONS.map((plan) => {
    const fetched = planConfig.plans[plan.id];
    if (!fetched) return plan;
    return {
      ...plan,
      price: formatPrice(fetched.price),
      includedFeatures: fetched.includedFeatures ?? plan.includedFeatures,
    };
  });
};

export default usePlanOptions;
